import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    title: 'Child Protection',
    to: '/services/child-protection',
    dark: true,
    icon: (
      <svg className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
    ),
  },
  {
    title: 'Child & Family Services',
    to: '/services/child-and-family-services',
    dark: false,
    icon: (
      <svg className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
      </svg>
    ),
  },
  {
    title: 'Housing & Accommodation',
    to: '/services/housing-and-accommodation',
    dark: true,
    icon: (
      <svg className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    title: 'Youth Services',
    to: '/services/youth-services',
    dark: false,
    icon: (
      <svg className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
        <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z" />
      </svg>
    ),
  },
  {
    title: 'Disability Services',
    to: '/services/disability-services',
    dark: true,
    icon: (
      <svg className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2" fill="currentColor" viewBox="0 0 429 425" aria-hidden>
        <path d="M186.65 65.48C186.5 83.08 171.98 97.22 154.18 97.09 136.38 96.97 122.03 82.62 122.1 65.02 122.17 47.42 136.64 33.22 154.43 33.27 172.23 33.32 186.64 47.61 186.65 65.21" />
        <path d="M127.72 81.54L141.43 239.56l116.89-.72 45.46 108.96 54.84-17.32-11.55-27.42-31.52 7.22-39.41-99.57H169.57V188.33h64.94V159.47H161.63l-1.44-62.93" />
        <path d="M124.22 161.75C-45.44 275.72 167.91 487.75 280.06 327.6l-12.38-42.56C217.81 422.65 14.3 311.9 126.28 199.16l-2.06-37.41z" />
      </svg>
    ),
  },
  {
    title: 'Social Enterprises',
    to: '/services/social-enterprises',
    dark: false,
    icon: (
      <svg className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden>
        <circle cx="6" cy="12" r="2.5" />
        <circle cx="18" cy="7" r="2.5" />
        <circle cx="18" cy="17" r="2.5" />
        <path d="M8.5 12L16 8" />
        <path d="M8.5 12L16 16" />
      </svg>
    ),
  },
];

const ServicesBar = () => {
  return (
    <section className="relative py-16 md:py-24 bg-ifys-light-gray overflow-hidden">
      {/* Plant decoration - top right */}
      <img
        src="/images/plant.png"
        alt=""
        aria-hidden
        loading="lazy"
        className="plant-decoration absolute -top-10 -right-10 w-40 h-40 md:w-56 md:h-56 object-contain pointer-events-none"
        style={{ transform: 'rotate(30deg)' }}
      />
      {/* Plant decoration - bottom left, flipped and rotated */}
      <img
        src="/images/plant.png"
        alt=""
        aria-hidden
        loading="lazy"
        className="plant-decoration absolute -bottom-10 -left-10 w-40 h-40 md:w-56 md:h-56 object-contain pointer-events-none"
        style={{ transform: 'scaleX(-1) scaleY(-1) rotate(30deg)' }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {services.map((service) => (
            <Link
              key={service.title}
              to={service.to}
              className={`flex flex-col items-center justify-center py-6 px-3 sm:py-8 sm:px-4 rounded-2xl sm:rounded-3xl text-white text-center font-medium text-sm sm:text-base shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-200 ease-smooth focus:outline-none focus:ring-2 focus:ring-ifys-blue focus:ring-offset-2 focus:ring-offset-white ${
                service.dark ? 'bg-ifys-blue' : 'bg-ifys-service-light'
              }`}
            >
              {service.icon}
              <span className="leading-tight">{service.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesBar;
